<template>
    <md-content class="card md-layout-item md-size-100 md-small-size-100">
        <div class="md-flex-center-center md-form-input md-relative">
            <h1 class="md-title md-form-title">
                {{ $t(`views.order.station.${this.isEditMode ? 'edit' : 'create'}`) }}
            </h1>
            <md-card class="md-form-card md-mt-70">
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                        <md-field :class="getValidationClass('stationId')">
                            <label for="station">{{ $t('views.order.station.form.label.station') }}</label>
                            <SelectWithFilter :list="stations" v-model="$v.form.stationId.$model" :name="`station`" 
                              :id="`station`" v-slot="{item}">
                                <md-option :value="item.id">{{ item.name }}</md-option>
                            </SelectWithFilter>
                            <span class="md-error" v-if="!$v.form.stationId.required">{{ $t('validation.required') }}</span>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                        <md-field>
                            <label for="bsPrice">{{ $t('views.order.station.form.label.bsPrice') }}</label>
                            <md-input :value="currentBsPrice" id="bsPrice" name="bsPrice"
                                      disabled />
                        </md-field>
                    </div>
                </div>

                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                        <div class="md-layout-item">
                            <label class="md-layout-item md-caption">{{ $t('views.order.station.form.label.stationShare') }}</label>
                            <span class="md-layout-item md-body-1">{{ form.stationShare }} %</span>
                        </div>
                        <div class="md-layout-item slider">
                            <slider v-model="form.stationShare" v-bind="sliderOptions"
                                    :marks="{1: '1%', [maxStationShare/2]: `${maxStationShare/2}%`, [maxStationShare]: `${maxStationShare}%`}"
                                    :min="1" :max="maxStationShare" />
                        </div>
                    </div>
                </div>
                
                <div class="md-layout md-alignment-center-right md-mt-30">
                    <md-button class="md-primary" :to="backUrl">{{ $t('views.order.station.buttons.cancel') }}</md-button>
                    <md-button class="md-accent md-raised" @click="addStation">{{ $t(`views.order.station.buttons.${this.isEditMode ? 'editStation' : 'addStation'}`) }}</md-button>
                </div>
            </md-card>
        </div>
    </md-content>
</template>

<script>
    import {required} from 'vuelidate/lib/validators';
    import serverSideValidationErrors from '@/mixins/serverSideValidationErrors';
    import {
        conditionsEndpoint,
        ordersEndpoint,
        orderStationsEndpoint,
        stationsEndpoint
    } from '@/services/adsign-backend/endpoints';
    import orderStations from '@/services/adsign-backend/endpoints/orderStations';
    import SelectWithFilter from '@/components/SelectWithFilter'

    export default {
        name: 'StationForm',
        mixins: [serverSideValidationErrors],
        components: {SelectWithFilter},
        props: {
            orderNo: {
                type: String,
                required: true
            },
            orderStationId: {
                type: String,
                default: null
            },
            backUrl: {
                type: String,
                required: true
            },
            draft: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            isEditMode() {
                return this.orderStationId != null;
            },
            currentBsPrice() {
                return this.stations.find((item) => item.id == this.form.stationId)?.bsPrice || 0;
            },
            maxStationShare() {
                return this.orderStations
                    .filter(station => station.id != this.orderStationId)
                    .reduce((share, item) => share - Math.round(item.stationShare * 100), 100);
            },
        },
        data: function() {
            return {
                sending: false,
                stations: [],
                orderStations: [],
                currentOrder: {},
                condition: null,
                lastOrderStationNo: 0,
                sliderOptions: {
                    contained: 'true',
                    tooltip: 'none',
                    processStyle: {backgroundColor: '#E51937'},
                    dotStyle: {backgroundColor: '#E51937'},
                    dotOptions: {
                        focusStyle: {boxShadow: 'none'}
                    }
                },
                form: {
                    id: this.orderStationId,
                    stationId: null,
                    stationShare: 1
                }
            }
        },
        methods: {
            createOrUpdateStation() {
                const stationData = {
                    stationId: this.form.stationId,
                    share: this.form.stationShare / 100,
                }
                if (this.isEditMode) {
                    return orderStations.updateOrderStation(this.orderNo, this.form.id, stationData, this.draft)
                        .then(result => result.data.id);
                } else {
                    return orderStations.createOrderStation(this.orderNo, stationData, this.draft)
                        .then(result => result.data.id);
                }
            },
            addStation() {
                this.$v.form.$touch();
                if (!this.$v.form.$invalid) {
                    this.createOrUpdateStation().then(() => {
                        this.$router.push(this.backUrl);
                    })
                }
            }
        },
        mounted() {
            ordersEndpoint.getStations(this.orderNo).then(result => this.stations.push(...result.data))

            orderStationsEndpoint.getOrderStations(this.orderNo).then(result => {
                this.orderStations = result.data;
                const currentOrderStation = this.orderStations.find((item) => item.id == this.orderStationId);

                if (currentOrderStation) {
                    this.form.stationId = currentOrderStation.id;
                    this.form.stationId = currentOrderStation.stationId;
                    this.form.stationShare = Math.round(currentOrderStation.stationShare * 100);
                    

                    stationsEndpoint.getStation(currentOrderStation.stationId).then(result => this.stations.push(result.data))
                }
            })
        },
        validations: {
            form: {
                stationId: {
                    required
                },
                stationShare: {}
            }
        }
    }
</script>

<style scoped lang="scss">
    .slider {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .md-layout-item.md-caption {
        margin-right: 40px;
    }
</style>
